import styled, { css, keyframes } from 'styled-components/macro';
import Modal from 'styled-react-modal';
import { device } from '../../device';
import Star from './Star.svg';

export const StyledModal = Modal.styled`
  max-width: 1000px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${(props) => props.opacity};
  transition : all 0.3s ease-in-out;
`;

export const StyledRateFormContainer = styled.form`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	max-width: 600px;
	background: #ffffff;
	border: 2px solid #ebedee;
	border-radius: 8px;
	position: relative;
	padding: 1rem 3rem;
	@media ${device.tablet} {
		padding: 1rem 2rem;
		margin: 1rem auto;
	}
	h2 {
		font-weight: 600;
		font-size: 32px;
		line-height: 48px;
		color: #575e68;
		padding: 1rem 0;
	}
	h3 {
		font-weight: normal;
		font-size: 21px;
		line-height: 31px;
		text-align: center;
		color: #575e68;
	}
`;

export const StyledX = styled.span`
	position: absolute;
	right: 2rem;
	top: 2rem;
	&:hover {
		cursor: pointer;
	}
`;
export const StyledLogo = styled.span`
	padding: 2rem 0;
`;

export const StyledButton = styled.button`
	color: #fcfcfd;
	font-weight: 600;
	font-size: 16px;
	line-height: 100%;
	width: 100%;
	background: #6270c6;
	border: 1px solid #939dd6;
	border-radius: 4px;
	text-decoration: none;
	padding: 0.8rem;
	&:hover {
		cursor: pointer;
	}
`;
export const StyledButtonLink = styled.a`
	margin: 2rem 0;
	color: #fcfcfd;
	width: 100%;
	background: #6270c6;
	border: 1px solid #939dd6;
	border-radius: 4px;
	text-decoration: none;
	font-weight: 600;
	font-size: 16px;
	line-height: 100%;
	padding: 0.8rem;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	svg {
		margin-right: 0.5rem;
	}
`;
export const StyledFeedbackTextarea = styled.textarea`
	width: 100%;
	height: 6rem;
	padding: 1rem;
	font-size: 16px;
	line-height: 100%;
	color: #111111;
	background: #f4f6f8;
	border: 1px solid #dddddd;
	border-radius: 4px;
	resize: none;
	margin: 2rem 0;
`;

export const StyledRateLater = styled.p`
	font-weight: normal;
	font-size: 16px;
	line-height: 100%;
	text-align: center;
	color: #575e68;
	opacity: 0.7;
	padding: 2rem 0;
	&:hover {
		cursor: pointer;
		text-decoration: underline;
	}
`;

export const StyledStars = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: row-reverse;
	padding: 1rem 0;
	${'' /* width: 100%; */}
`;

export const StyledStarsInput = styled.input`
	position: absolute;
	left: -99999px;
`;

export const StyledStarLabel = styled.label`
	color: transparent;
	transition: all 0.1s ease-in-out;
	&:hover {
		cursor: pointer;
	}
	&:before {
		content: url(${Star});
		opacity: 0.2;
		transition: all 0.1s ease-in-out;
		svg {
			height: 30px;
			width: 30px;
		}
		@media ${device.tablet} {
		}
	}
	&:hover {
		&:before {
			opacity: 1;
		}
	}
	&:hover {
		& ~ label:before {
			opacity: 1;
		}
	}

	${(props) =>
		props.checked &&
		css`
			animation: ${checked} 0.5s ease-in-out 1 both;
			&:before {
				opacity: 1;
			}
		`}
`;
const checked = keyframes`
  0% {
			transform: scale(1);
		}
		50% {
			transform: scale(1.2);
		}
		100% {
			transform: scale(1);
		}
`;
